import { Component } from "@angular/core";

@Component({
    selector: "app-help",
    templateUrl: "./help.component.html",
    styleUrls: ["./help.component.less"],
    standalone: false
})
export class HelpComponent {

    constructor() {}

}
